module.exports = __webpack_public_path__ + "static/img/toolbox-restore.6cc21c54.svg";